"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var NotificationItem_1 = __importDefault(require("../../NotificationItem"));
var PitchIcon_1 = __importDefault(require("../../../Icons/Notifications/PitchIcon"));
var i18N = {
    en: {
        description: function (link) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "Help to advance this idea by proposing potential solutions",
            ' ',
            react_1.default.createElement("a", { href: link, className: "dcl notification-link" }, "here"),
            ".")); },
        title: function (proposalTitle) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "The Pitch \"",
            react_1.default.createElement("span", { className: "dcl notification-text-highlighted" }, proposalTitle),
            "\" can now receive Tenders")); }
    },
    es: {
        description: function (link) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "Ayuda a avanzar esta idea proponiendo soluciones potenciales",
            ' ',
            react_1.default.createElement("a", { href: link, className: "dcl notification-link" }, "aqu\u00ED"),
            ".")); },
        title: function (proposalTitle) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "La Convocatoria \"",
            react_1.default.createElement("span", { className: "dcl notification-text-highlighted" }, proposalTitle),
            "\" ahora puede recibir licitaciones")); }
    },
    zh: {
        description: function (link) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "\u901A\u8FC7\u63D0\u51FA\u53EF\u80FD\u7684\u89E3\u51B3\u65B9\u6848\u6765\u5E2E\u52A9\u63A8\u8FDB\u8FD9\u4E2A\u60F3\u6CD5",
            ' ',
            react_1.default.createElement("a", { href: link, className: "dcl notification-link" }, "\u8FD9\u91CC"),
            ".")); },
        title: function (proposalTitle) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "\u6295\u6807\u9080\u8BF7 \"",
            react_1.default.createElement("span", { className: "dcl notification-text-highlighted" }, proposalTitle),
            "\" \u73B0\u5728\u53EF\u4EE5\u63A5\u6536\u6295\u6807")); }
    }
};
var GovernancePitchPassedNotification = function (_a) {
    var notification = _a.notification, locale = _a.locale;
    return (react_1.default.createElement(NotificationItem_1.default, { image: { image: react_1.default.createElement(PitchIcon_1.default, { width: "48", height: "48" }) }, timestamp: notification.timestamp, isNew: !notification.read, locale: locale },
        react_1.default.createElement("p", { className: "dcl notification-item__content-title" }, i18N[locale].title(notification.metadata.proposalTitle)),
        react_1.default.createElement("p", { className: "dcl notification-item__content-description" }, i18N[locale].description(notification.metadata.link))));
};
exports.default = GovernancePitchPassedNotification;
